import React from 'react';

const colors = [    
    'background',
    'foreground',
    'card',
    'card-foreground',
    'popover',
    'popover-foreground',
    'primary',
    'primary-foreground',
    'secondary',
    'secondary-foreground',
    'muted',
    'muted-foreground',
    'accent',
    'accent-foreground',
    'destructive',
    'destructive-foreground',
    'border',
    'input',
    'ring',
    'radius',
    'chart-1',
    'chart-2',
    'chart-3',
    'chart-4',
    'chart-5',
    'sidebar-background',
    'sidebar-foreground',
    'sidebar-primary',
    'sidebar-primary-foreground',
    'sidebar-accent',
    'sidebar-accent-foreground',
    'sidebar-border',
    'sidebar-ring',
];

const TestTailwind: React.FC = () => {
    return (
        <div className="p-4">
            <h1 className="text-2xl font-bold mb-4">Tailwind Colors</h1>
            <div className="grid grid-cols-2 gap-4">
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-background border"></div>
                    <span className="text-lg">background</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-foreground border"></div>
                    <span className="text-lg">foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-card border"></div>
                    <span className="text-lg">card</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-card-foreground border"></div>
                    <span className="text-lg">card-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-popover border"></div>
                    <span className="text-lg">popover</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-popover-foreground border"></div>
                    <span className="text-lg">popover-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-primary border"></div>
                    <span className="text-lg">primary</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-primary-foreground border"></div>
                    <span className="text-lg">primary-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-secondary border"></div>
                    <span className="text-lg">secondary</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-secondary-foreground border"></div>
                    <span className="text-lg">secondary-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-muted border"></div>
                    <span className="text-lg">muted</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-muted-foreground border"></div>
                    <span className="text-lg">muted-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-accent border"></div>
                    <span className="text-lg">accent</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-accent-foreground border"></div>
                    <span className="text-lg">accent-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-destructive border"></div>
                    <span className="text-lg">destructive</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-destructive-foreground border"></div>
                    <span className="text-lg">destructive-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-border border"></div>
                    <span className="text-lg">border</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-input border"></div>
                    <span className="text-lg">input</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-ring border"></div>
                    <span className="text-lg">ring</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-radius border"></div>
                    <span className="text-lg">radius</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-chart-1 border"></div>
                    <span className="text-lg">chart-1</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-chart-2 border"></div>
                    <span className="text-lg">chart-2</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-chart-3 border"></div>
                    <span className="text-lg">chart-3</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-chart-4 border"></div>
                    <span className="text-lg">chart-4</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-chart-5 border"></div>
                    <span className="text-lg">chart-5</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-sidebar-background border"></div>
                    <span className="text-lg">sidebar-background</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-sidebar-foreground border"></div>
                    <span className="text-lg">sidebar-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-sidebar-primary border"></div>
                    <span className="text-lg">sidebar-primary</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-sidebar-primary-foreground border"></div>
                    <span className="text-lg">sidebar-primary-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-sidebar-accent border"></div>
                    <span className="text-lg">sidebar-accent</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-sidebar-accent-foreground border"></div>
                    <span className="text-lg">sidebar-accent-foreground</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-sidebar-border border"></div>
                    <span className="text-lg">sidebar-border</span>
                </div>
                <div className="flex items-center space-x-4">
                    <div className="w-16 h-16 bg-sidebar-ring border"></div>
                    <span className="text-lg">sidebar-ring</span>
                </div>
            </div>
        </div>
    );
};

export default TestTailwind;